import { Card } from '../../../../../../components/card/card';
import { Checkbox } from '../../../../../../components/checkbox/checkbox';
import {
  dishPhotoKey,
  dishNameKey,
  dishCategoryKey,
  dishCostKey,
} from '../../../../../../features/table/helpers';
import { Table } from '../../../../../../features/table/table';
import { TableFilterInput } from '../../../../../../features/table/table-filter/table-filter-input/table-filter-input';
import { TableFilterMultiSelect } from '../../../../../../features/table/table-filter/table-filter-multi-select/table-filter-multi-select';
import { TableFilterRange } from '../../../../../../features/table/table-filter/table-filter-range/table-filter-range';
import { TableFilterSingleSelect } from '../../../../../../features/table/table-filter/table-filter-single-select/table-filter-single-select';
import { useLang } from '../../../../../../hooks/use-lang';
import { useIikoStore } from '../../../../../../store/use-iiko-store';
import s from './menu-iiko-table.module.css';
import dishImage from '../../../../../../assets/images/food-mock.png';
import { MenuIikoTableHeader } from './menu-iiko-table-header/menu-iiko-table-header';

export const MenuIikoTable = () => {
  const { t, getLocale } = useLang();
  const { menu } = useIikoStore();

  return (
    <Card>
      <Table
        id="menu-iiko"
        columnSettings
        frontPagination
        className={s.feature}
        header={{ children: <MenuIikoTableHeader />, className: s.header }}
        cols={{
          available: {
            label: t('Доступно к заказу'),
            filter: (
              <TableFilterSingleSelect
                name="available"
                options={[
                  { id: 'true', value: 'Да' },
                  { id: 'false', value: 'Нет' },
                ]}
              />
            ),
          },
          photo: {
            label: t('Изображение'),
            filter: (
              <TableFilterSingleSelect
                options={[
                  { id: 'true', value: 'С фото' },
                  { id: 'false', value: 'Без фото' },
                ]}
                name={dishPhotoKey}
              />
            ),
          },
          dishName: {
            label: t('Название'),
            filter: (
              <TableFilterInput
                name={dishNameKey}
                suggestOptions={menu?.dishes?.map((item) => getLocale(item.name))}
              />
            ),
          },
          category: {
            label: t('Категория'),
            filter: (
              <TableFilterMultiSelect
                options={menu?.categories?.map((item) => ({
                  id: String(item.id),
                  value: getLocale(item.name),
                }))}
                name={dishCategoryKey}
              />
            ),
          },
          cost: { label: t('Цена'), filter: <TableFilterRange name={dishCostKey} /> },
        }}
        rows={menu?.dishes?.map((item) => ({
          available: <Checkbox checked={item.is_on} disabled />,
          photo: (
            <img
              src={item.images?.main?.thumbnail || item.images?.main?.normal || dishImage}
              alt={getLocale(item.name)}
              className={s.image}
            />
          ),
          dishName: getLocale(item.name),
          category: getLocale(
            menu?.categories?.find((category) => category.id === item.category_id)?.name,
          ),
          cost: item.prices?.primary?.price,
        }))}
        onEmpty={{
          text: t('Добавьте блюдо в iiko меню и синхронизируйте его с Informer'),
        }}
      />
    </Card>
  );
};
